import Service from "./Service";

export class CategoryService extends Service{
    constructor() {
        super();
        this.baseURL = 'category';
    }
}